import React, { cloneElement, createElement, useState } from "react";
import classNames from "classnames";
import { useTransition, animated } from "@react-spring/web";
import { BaseProps } from "../common/BaseProps";
import { getProperty } from "../common/Utils";

/**
 * enterStyles: 进入前的动画属性
 * leaveStyles: 离开后的动画属性
 * activeStyles: 进入时的动画属性
 */
export interface TransitionProps extends BaseProps {
  enterStyles?: Array<any>;
  leaveStyles?: Array<any>;
  activeStyles?: Array<any>;
  styles?: () => void;
  transitionName?: string;
  wrapperComponent?: any;
  willEnter?: () => void;
  willLeave?: () => void;
  didLeave?: (style: any) => void;
}

export interface TransitionState {}

export default function TransitionGroup(props: TransitionProps) {
  const {
    className,
    transitionName,
    prefixCls = "bm-RouteTransition",
    enterStyles = {},
    activeStyles = {},
    leaveStyles = {},
  } = props;
  const styleClass = classNames(prefixCls, className, transitionName);
  const [activeIndex, setActiveIndex] = useState(0);

  const transitions = useTransition(activeIndex, {
    from: getProperty(enterStyles),
    enter: getProperty(activeStyles),
    leave: getProperty(leaveStyles),
    exitBeforeEnter: true,
  });

  const renderElement = (config: any = {}) => {
    const props2: any = {
      key: config.key,
    };
    return !!props.wrapperComponent !== false
      ? createElement(props.wrapperComponent, props2, config.data)
      : cloneElement(config.data, props2);
  };

  return transitions((style) => (
    <animated.div className={styleClass} style={style}>
      {renderElement({
        data: props.children,
        key:
          (props.children as any)?.key ||
          `transition_${Math.floor(Math.random() * 100)}`,
      })}
    </animated.div>
  ));
}
